module.exports = __webpack_public_path__ + "static/full04-6db4b99c2e3d8d503265a5b9380b601a.png";